export const MESSAGE_VARIABLES = {
  cashback_used: "Rewards Applied:",
  cashback: "Rewards:",
};


export const PRODUCT_STATUS = {
  VOID: "VOID",
};

export const ORDER_STATUSES = {
  COMP_AFTER_TXN: "COMP_AFTER_TXN",
  COMP_BEFORE_TXN: "COMP_BEFORE_TXN",
};